// Languages extension (admin side): which languages the product exists in.
// The tab is the old catalog editor's LanguagesTab, reused as it is — it reads and
// writes through the shared catalog editor (../shared/catalog-editor.jsx).
import { LanguageIcon } from "@heroicons/react/24/outline"
import LanguagesTab from "./LanguagesTab"
import { CatalogEditorProvider, catalogSection, catalogVisible, useCatalogVisibilityContext } from "../shared/catalog-editor"

export const StoreProductExtension = {
  id: "languages",
  label: "Languages",
  description: "The languages the product is available in",
  section: {
    component: catalogSection(LanguagesTab),
    label: "Languages",
    icon: LanguageIcon,
    order: 700,
    visible: catalogVisible("languages"),
  },
  provider: CatalogEditorProvider,
  visibilityContext: useCatalogVisibilityContext,
}
